export default "__VITE_ASSET__BsdJkFOe__"